import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResultsViewComponent } from './components/results-view/results-view.component';
import { AdvSearchViewComponent } from './components/adv-search-view/adv-search-view.component';
import { SearchResolverService } from './resolvers/search-resolver.service';
import { MetadataResolverService } from './resolvers/metadata-resolver.service';
import { HomeCleanViewComponent } from './components/home-clean-view/home-clean-view.component';
import { DocPropertiesViewComponent } from './components/doc-properties-view/doc-properties-view.component';
import { PropertyViewResolverService } from './resolvers/property-view-resolver.service';
import { GlossaryViewComponent } from './components/glossary-view/glossary-view.component';
import { LastIndexDateResolverService } from './resolvers/last-index-date-resolver.service';
import { ErrorViewComponent } from './components/error-view/error-view.component';
import { AnnouncementsResolverService } from './resolvers/announcements-resolver.service';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeCleanViewComponent, resolve: { metadataProps: MetadataResolverService, indexDate: LastIndexDateResolverService, announcements: AnnouncementsResolverService}, runGuardsAndResolvers: 'paramsChange' },
  { path: 'results/:q', component: ResultsViewComponent, resolve: { results: SearchResolverService, indexDate: LastIndexDateResolverService }, runGuardsAndResolvers: 'paramsChange' },
  { path: 'adv-search', component: AdvSearchViewComponent, resolve: { metadataProps: MetadataResolverService, indexDate: LastIndexDateResolverService }, runGuardsAndResolvers: 'paramsChange' },
  { path: 'props/:id', component: DocPropertiesViewComponent, resolve: { props: PropertyViewResolverService, indexDate: LastIndexDateResolverService } },
  { path: 'terms', component: GlossaryViewComponent, resolve: {indexDate: LastIndexDateResolverService }},
  { path: 'error', component: ErrorViewComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
